import { ContactModal } from "../components/ContactModal";
import { Footer } from "../components/Footer";
import { Header } from "../components/Header";
import { useContactModal } from "../context/contactModal";
import { COMPANY } from "../data/company";
export const LegalEntityPage = () => {
  const { isOpen, closeModal } = useContactModal();
  const n = [
    {
      label: "Company name",
      value: COMPANY.legalName,
    },
    {
      label: "Brand",
      value: COMPANY.brandName,
    },
    {
      label: "EIN",
      value: COMPANY.ein,
    },
    {
      label: "Delaware file number",
      value: COMPANY.delawareFileNumber,
    },
    {
      label: "Date of incorporation, Delaware",
      value: COMPANY.delawareIncorporationDate,
    },
    {
      label: "NYS DOS / file number",
      value: COMPANY.nysDosFileNumber,
    },
    {
      label: "NYS foreign qualification date",
      value: COMPANY.nysForeignQualificationDate,
    },
  ];
  return (
    <div className="min-h-screen bg-[#131313]">
      <Header />
      <main>
        <section className="pt-48 pb-20 bg-[#131313] text-white">
          <div className="container mx-auto px-4">
            <div className="mx-auto max-w-4xl">
              <p className="mb-4 text-base font-bold uppercase tracking-[0.18em] text-[#B3C9FE]">
                Legal Entity
              </p>
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold">Impact Frontiers Inc.</h1>
              <p className="mt-6 max-w-3xl text-base leading-relaxed text-gray-300">
                Actrium AI is the public-facing brand operated by {COMPANY.legalName}, a Delaware corporation
                qualified to do business in New York.
              </p>
            </div>
          </div>
        </section>
        <section className="py-20 bg-[#101010] text-white">
          <div className="container mx-auto px-4">
            <div className="mx-auto max-w-4xl">
              <div className="grid gap-4 md:grid-cols-2">
                {n.map((r) => (
                  <div className="rounded-md border border-white/10 bg-white/[0.04] p-5" key={r.label}>
                    <p className="text-base text-gray-400">{r.label}</p>
                    <p className="mt-2 text-base font-semibold text-white">{r.value}</p>
                  </div>
                ))}
              </div>
              <div className="mt-8 rounded-md border border-white/10 bg-white/[0.04] p-6">
                <h2 className="text-2xl font-bold text-white">Registered address</h2>
                <address className="mt-4 not-italic text-base leading-relaxed text-gray-300">
                  {COMPANY.addressLine1}
                  <br />
                  {COMPANY.addressLine2}
                </address>
              </div>
              <div className="mt-8 rounded-md border border-white/10 bg-white/[0.04] p-6">
                <h2 className="text-2xl font-bold text-white">Original filings</h2>
                <div className="mt-4 flex flex-col gap-3 sm:flex-row">
                  {COMPANY.legalDocuments.map((r) => (
                    <a
                      href={r.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center justify-center rounded-md border border-white/15 px-5 py-3 text-base font-bold text-white transition-colors hover:border-[#006AFF] hover:text-[#B3C9FE]"
                      key={r.href}
                    >
                      View original PDF: {r.label}
                    </a>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
      <ContactModal isOpen={isOpen} onClose={closeModal} />
    </div>
  );
};
